import { useState, useCallback } from 'react';
import { transferService } from '@/features/transfers/services/transferService';

interface TransferData {
  fromAccountId: string;
  toAccountCbu: string;
  amount: number;
  description: string;
}

interface UseTransferReturn {
  transfer: (data: TransferData) => Promise<boolean>;
  validateCbu: (cbu: string) => Promise<{ valid: boolean; holderName?: string; bankName?: string }>;
  isLoading: boolean;
  isValidating: boolean;
  error: string | null;
  success: boolean;
}

export function useTransfer(): UseTransferReturn {
  const [isLoading, setIsLoading] = useState(false);
  const [isValidating, setIsValidating] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const transfer = useCallback(async (data: TransferData): Promise<boolean> => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      await transferService.createTransfer(data);
      setSuccess(true);
      return true;
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Error al realizar la transferencia');
      return false;
    } finally {
      setIsLoading(false);
    }
  }, []);

  const validateCbu = useCallback(async (cbu: string) => {
    setIsValidating(true);
    try {
      return await transferService.validateCbu(cbu);
    } finally {
      setIsValidating(false);
    }
  }, []);

  return {
    transfer,
    validateCbu,
    isLoading,
    isValidating,
    error,
    success,
  };
}
